import PropTypes from "prop-types";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
//import StatusNew from "../../../../../tasks/scenes/telerik-tasks/common-components/status-new";
import StatusBadge from "../subcomponents/StatusBadge";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";

const EDITABLE_BASE_NAMES = new Set(["Not Started", "Re-assign Task", "Archive", "Teams Chat", "In Progress"]);

const BaseStatusRow = ({ field, index, onHide, onOpen }) => {
  const editable = EDITABLE_BASE_NAMES.has(field?.Name);
  const hideDisabled = field?.IsInitialStatus;

  return (
    <div className="individual-workflow" id={`workflowstatusBase_${index}`}>
      <div className="individual-workflow-status">
        <span className="status-index">{index + 1}</span>
        <div className="field-container-base-status pl-2">
          <FluentProvider theme={webLightTheme}>
            <StatusBadge status={field} />
          </FluentProvider>
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 150 }}
            overlay={
              <Tooltip id="button-tooltip">
                { field?.IsInitialStatus
                    ? "This Task Status has been set as the Workflow starting point. You can’t hide it from the workflow."
                    : "Click to Hide"
                }
              </Tooltip>
            }
          >
            <Button
              className={`btn-icon1 hide-eye-icon ${hideDisabled ? "hide-eye-icon-disabled" : ""}`}
              onClick={() => {
                if (!hideDisabled) onHide(field.Id, field?.IsHidden);
              }}
              type="button"
            />
          </OverlayTrigger>
        </div>

        {editable ? (
          <Button className="btn-icon1 open-modal" onClick={() => onOpen(field)} type="button" />
        ) : (
          <OverlayTrigger
            placement="top"
            delay={{ show: 150, hide: 150 }}
            overlay={<Tooltip id="button-tooltip">TRIYO created this Task Status. You can’t edit its name and properties.</Tooltip>}
          >
            <Button className="btn-icon1 lock-closed-icon" type="button" />
          </OverlayTrigger>
        )}
      </div>
    </div>
  );
};

BaseStatusRow.propTypes = {
  field: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onHide: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
};

export default BaseStatusRow;

// Apply the coloring logic for these Base badges

// Not Started
// background: "#F0F0F0", color: "#616161", border: "1px solid #E0E0E0"

// In Progress
// background: "#EDBBE7", color: "#AF33A1", border: "1px solid #FDF5FC"

// Pending Approval
// background: "#F9E2AE", color: "#835B00", border: "1px solid #FEFBF4"

// Completed
// background: "#F1FAF1", color: "#0E700E", border: "1px solid #9FD89F"

// Cancelled
// background: "#FDF6F6", color: "#BC2F32", border: "1px solid #F1BBBC"

// Overdue
// background: "#FDF6F3", color: "#C43501", border: "1px solid #F4BFAB"
